import { Button, Grid, Tooltip, Typography } from "@mui/material"
import { ModalComponent } from "../../../../../../../components/modal"
import animationSMS from "../../../../../../../assets/animation/sms.json"
import Lottie from "react-lottie"
import { Timer } from "../../../../../../../components/timer"
import { useNavigate } from "react-router-dom"
import useAuth from "../../../../../../../context/auth"
import { PinCode } from "./pin"
import { useEffect, useState } from "react"
import { LoadingButton } from "@mui/lab"
import { ClientsService } from "../../../../../../../services/clients"
import { ModalChangeNumber } from "./number"
import moment from "moment"

interface Props {
    open: boolean,
    onClose: () => void
}

const options = {
    loop: true,
    autoplay: true,
    animationData: animationSMS,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

export const ModalConfirmNumber = ({
    onClose,
    open
}: Props) => {
    const { getData } = useAuth()
    const [disabled, setDisabled] = useState(true)
    const [loading, setLoading] = useState(false)
    const [code, setCode] = useState("")
    const [openUpdateNumber, setOpenUpdateNumber] = useState(false)
    const [seconds, setSeconds] = useState(0)

    const totalTime = 60

    const checkCode = () => {
        setLoading(true)
        ClientsService.checkSMSCode(code)
            .then(() => {
                onClose()
                getData()
            })
            .finally(() => setLoading(false))
    }

    const handleTime = async () => {
        localStorage.setItem("update_number_at", new Date().toISOString())
        setSeconds(totalTime)
    }

    useEffect(() => {
        const updateNumberAt = localStorage.getItem("update_number_at")

        if (updateNumberAt) {
            const diff = moment().diff(moment(updateNumberAt), "seconds")
            setSeconds(totalTime - diff)
        }
    }, [])

    return (
        <ModalComponent
            open={open}
            withoutHeader
        >
            <Grid
                width={"100%"}
                display={"flex"}
                direction={"column"}
                gap={"1.7rem"}
                alignItems={"center"}
            >

                <div style={{ width: "20.2rem", height: 'auto', margin: "-2rem -4rem -2rem 0px" }}>
                    <Lottie options={options} />
                </div>

                <Typography fontWeight={700} textAlign={"center"} fontSize={"3.2rem"}>Verifique seu SMS</Typography>

                <Typography fontSize={"1.4rem"} sx={{ opacity: .5 }} textAlign={"center"}>
                    Digite abaixo o código de verificação que lhe enviamos por mensagem SMS
                </Typography>

                <PinCode onChange={(confirm, value) => {
                    setDisabled(!confirm)
                    setCode(value)
                }} />

                <LoadingButton variant="contained" disabled={disabled} loading={loading} onClick={checkCode}>Continuar</LoadingButton>

                <Button sx={{
                    color: "gray",
                    textDecoration: "underline",
                    height: "2.5rem"
                }}
                    disabled={seconds > 0}
                    onClick={() => setOpenUpdateNumber(true)}
                >Cadastrou o número errado? {seconds > 0 && <>(<Timer
                    hours={seconds}
                    onTimerZero={() => {
                        setSeconds(0)
                    }}
                    withDelay={0}
                />)</>}</Button>
            </Grid>

            <ModalChangeNumber open={openUpdateNumber} onClose={(sended) => {
                if (sended) {
                    handleTime()
                }
                setOpenUpdateNumber(false)
            }} />
        </ModalComponent>
    )
}